import React, { useState } from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useGetAllClearanceQuery } from "store/slices/apis/clearancePackageSlice";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

type Person = {
  //sno: string;
  approval_compliance_description: string;
  approving_authority_agency: string;
  status: string;
  compliance_owner: string;
  plan_date: string;
  actual_expected_date: string;
};

const columns: MRT_ColumnDef<Person>[] = [
  // { accessorKey: 'sno', header: 'S No.' },
  { accessorKey: 'approval_compliance_description', header: 'Approval Compliance Description', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center', sx: { whiteSpace: 'nowrap' }, }, },
  { accessorKey: 'approving_authority_agency', header: 'Approving Authority Agency', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center', sx: { whiteSpace: 'nowrap' }, }, },
  { accessorKey: 'status', header: 'Status', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'compliance_owner', header: 'Compliance Owner', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'plan_date', header: 'Plan Date', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'actual_expected_date', header: 'Actual/Expected Date', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
];

// Format helper
const formatDate = (dateString?: string) =>
  dateString ? dayjs(dateString).format('DD/MM/YY') : '';

// Flatten formatter (no children)
const formatScheduleData = (data: any[]): Person[] =>
  data.map((item) => ({
    // sno: item.sno,
    approval_compliance_description: item.approval_compliance_description,
    approving_authority_agency: item.approving_authority_agency,
    status: item.status,
    compliance_owner: item.compliance_owner,
    plan_date: formatDate(item.plan_date),
    actual_expected_date: formatDate(item.actual_expected_date),
  }));

export default function KeyClearancesList() {
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const { data, isLoading, error } = useGetAllClearanceQuery({
    projectId,
    sortBy: "createddate",
    sortOrder: "desc",
    approved_status: "Approved",
    pageSize,
    page: pageNumber,
  });

  const dataval: Person[] = data?.data ? formatScheduleData(data?.data) : [];

  return (
    <Box sx={{ mt: 1, width: "100%", borderRadius: "12px", overflow: "hidden", backgroundColor: "#fff", }}>
      <Box sx={{ backgroundColor: "#fff", p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "18px", color: `${newtheme?.customSettings?.themeColor}` }}>
          Key Clearances List
        </Typography>
        <Typography sx={{ color: "#666" }}>
          Total statutory clearances required
        </Typography>
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={4} pb={1}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">Failed to load data.</Typography>
      ) : (
        <MaterialReactTable
          columns={columns}
          data={dataval}
          enableRowNumbers
          rowNumberDisplayMode="static"
          displayColumnDefOptions={{
            'mrt-row-numbers': {
              header: 'S No',
              size: 100,
              muiTableHeadCellProps: { align: 'center' },
              muiTableBodyCellProps: { align: 'center' },
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontWeight: 500,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#F8F8F8",
              border: "1px solid #D8D8D8",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              fontWeight: 400,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D8D8D8",
              opacity: "0.54"
            },
          }}
          enableExpanding={false}
          enableRowSelection={false}
          enableFullScreenToggle={false}
        />
      )}
    </Box>
  );
}
